import { OpenEndedCreditStoreService } from '@hb/modules/financial-obligations/open-ended-credit/open-ended-credit-store.service';
import { OpenEndedCreditQuestion } from '@hb/domain/steps/financial-obligation';
import { PreviousButtonComponent } from '@hb/modules';
import { OpenEndedCreditAmountComponent } from '@hb/modules/financial-obligations/open-ended-credit/open-ended-credit-amount/open-ended-credit-amount.component';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'open-ended-credit',
    templateUrl: './open-ended-credit.component.html',
    imports: [PreviousButtonComponent, OpenEndedCreditAmountComponent, ApContentPipe],
    styleUrls: ['../../global/global.scss']
})
export class OpenEndedCreditComponent implements OnInit, OnDestroy {
    protected readonly store = inject(OpenEndedCreditStoreService);
    protected activeQuestion: OpenEndedCreditQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showOpenEndedCreditAmount(): boolean {
        return (
            this.activeQuestion === OpenEndedCreditQuestion.AMOUNT ||
            (this.store.isActiveQuestion(OpenEndedCreditQuestion.AMOUNT) && this.store.isSummary)
        );
    }
}
